define('pwa/controller/DashboardController',['require','lib/controller/BaseController','pwa/view/controller/dashboard/DashboardView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var DashboardView = require('pwa/view/controller/dashboard/DashboardView');

    /**
     * Contacts Controller
     *
     * @class ContactsController
     */
    return BaseController.extend({

        _model: null,
        _view: null,

        dashboard: function () {
            this._view = new DashboardView({
                app: this.getOption('app'),
                clientModel: this.getOption('clientModel'),
            });

            this.getMainLayout().getContentRegion().show(this._view);
        },

    });

});
